/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExternalEvaluationReport,
    ExternalEvaluationReportFromJSON,
    ExternalEvaluationReportFromJSONTyped,
    ExternalEvaluationReportToJSON,
} from './ExternalEvaluationReport';
import {
    RecomandationStatusEnum,
    RecomandationStatusEnumFromJSON,
    RecomandationStatusEnumFromJSONTyped,
    RecomandationStatusEnumToJSON,
} from './RecomandationStatusEnum';

/**
 * 
 * @export
 * @interface Recommendation
 */
export interface Recommendation {
    /**
     * 
     * @type {string}
     * @memberof Recommendation
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof Recommendation
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Recommendation
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Recommendation
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Recommendation
     */
    officialName?: string | null;
    /**
     * 
     * @type {RecomandationStatusEnum}
     * @memberof Recommendation
     */
    state?: RecomandationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Recommendation
     */
    externalEvaluationId?: string;
    /**
     * 
     * @type {ExternalEvaluationReport}
     * @memberof Recommendation
     */
    externalEvaluation?: ExternalEvaluationReport;
}

export function RecommendationFromJSON(json: any): Recommendation {
    return RecommendationFromJSONTyped(json, false);
}

export function RecommendationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Recommendation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'officialName': !exists(json, 'officialName') ? undefined : json['officialName'],
        'state': !exists(json, 'state') ? undefined : RecomandationStatusEnumFromJSON(json['state']),
        'externalEvaluationId': !exists(json, 'externalEvaluationId') ? undefined : json['externalEvaluationId'],
        'externalEvaluation': !exists(json, 'externalEvaluation') ? undefined : ExternalEvaluationReportFromJSON(json['externalEvaluation']),
    };
}

export function RecommendationToJSON(value?: Recommendation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'description': value.description,
        'officialName': value.officialName,
        'state': RecomandationStatusEnumToJSON(value.state),
        'externalEvaluationId': value.externalEvaluationId,
        'externalEvaluation': ExternalEvaluationReportToJSON(value.externalEvaluation),
    };
}

